module.exports = __webpack_public_path__ + "assets/images/JMDC10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDC10.png
// module id = 1399
// module chunks = 1